'use client'

import { type FC } from 'react'

import { NowGeneralContextProvider } from '../../../now'
import {
  ProductSearchRefinementsButton,
  ProductSearchResultInfo,
} from '../../../product-search'
import { type StoryblokComponentProps } from '../../model'
import { type StoryblokAlgoliaCategorySearchType } from '../../storyblok'
import { StoryblokAlgoliaSearch } from '../StoryblokAlgoliaSearch/StoryblokAlgoliaSearch'

import { storyblokAlgoliaCategoryOrPznSearchFilters } from './storyblokAlgoliaCategoryOrPznSearchFilters'
import { StoryblokAlgoliaCategorySearchResults } from './StoryblokAlgoliaCategorySearchResults'
import { StoryblokAlgoliaCategorySearchSidebar } from './StoryblokAlgoliaCategorySearchSidebar'

export const StoryblokAlgoliaCategorySearch: FC<
  StoryblokComponentProps<StoryblokAlgoliaCategorySearchType>
> = ({ blok }) => {
  const filtersValue = storyblokAlgoliaCategoryOrPznSearchFilters(blok)
  const hasFilters = filtersValue.length > 0
  const filters = hasFilters ? filtersValue : undefined

  return (
    <NowGeneralContextProvider>
      <StoryblokAlgoliaSearch filters={filters}>
        <div
          className="flex flex-col gap-3 desktop:gap-6"
          data-qa-id="category-page-search"
        >
          <div className="flex flex-col gap-3 desktop:gap-6">
            <ProductSearchRefinementsButton className="desktop:hidden" />
            <ProductSearchResultInfo />
          </div>
          <div className="grid gap-4 pt-5 desktop:grid-cols-10 desktop:items-start desktop:gap-6 desktop:pt-0">
            <StoryblokAlgoliaCategorySearchSidebar />
            <StoryblokAlgoliaCategorySearchResults />
          </div>
        </div>
      </StoryblokAlgoliaSearch>
    </NowGeneralContextProvider>
  )
}
